import { apiClient } from '@/lib/api/client';
import { endpoints } from '@/lib/api/endpoints';
import { parseContract } from '@/lib/api/parse';

import { mapDeviceListResponseSchema, type MapDeviceListResponse } from './map-schemas';

/**
 * Every located Device with its Field association.
 *
 * **No `bbox`, ever** — 113586 §11c requires a Cluster marker's count to equal the exact number of
 * elements it represents, and a viewport slice cannot count what it never fetched (ADR-0016
 * § Loading). The same rule is what keeps split-and-re-merge symmetric as the Grower zooms.
 *
 * Its own call, separate from the Fields one, so the two layers fail independently
 * (113586 §15b/§15c) without any server support.
 */
export async function getMapDevices(): Promise<MapDeviceListResponse> {
  const path = endpoints.devices.map;
  return parseContract(mapDeviceListResponseSchema, await apiClient.getList(path), path);
}
